/**
 * `components.MuiFormHelperText` — helper text margins for filled/outlined fields.
 * Discoverability: `MuiFormHelperText`, `FormHelperText`, `contained`.
 *
 * @see https://mui.com/material-ui/api/form-helper-text/
 *
 */
import type { Components, Theme } from '@mui/material/styles';

export function muiFormHelperText(_theme: Theme): Pick<Components<Theme>, 'MuiFormHelperText'> {
  return {
    MuiFormHelperText: {
      styleOverrides: {
        contained: {
          marginLeft: 12,
          marginRight: 0,
        },
      },
    },
  };
}
